import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

const mutasiTunggakanPdf = (periode, data) => {
  const doc = new jsPDF({ orientation: "portrait" });
  const pageWidth = doc.internal.pageSize.getWidth();
  const loadImageAsDataURL = (url) => {
  return fetch(url)
    .then((res) => res.blob())
    .then(
      (blob) =>
        new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result);
          reader.onerror = reject;
          reader.readAsDataURL(blob);
        })
    );
};
const drawHeader = (judul, subJudul, logoDataUrl) => {
  const logoX = 10;
  const logoY = 8;
  const logoSize = 18;
  const textX = logoX + logoSize + 3;

  if (logoDataUrl) {
    doc.addImage(
      logoDataUrl,
      "PNG",
      logoX,
      logoY,
      logoSize,
      logoSize
    );
  }

  doc.setFont("helvetica", "bold");
  doc.setFontSize(12);
  doc.text("KPRI SRI REJEKI", textX, 15);

  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  doc.text("Jl. Donomulyo No.164 Kab. Malang", textX, 21);

  const lineY = logoY + logoSize + 4;

  doc.setLineWidth(0.5);
  doc.line(10, lineY, pageWidth - 10, lineY);

  const reportY = lineY + 8;

  doc.setFont("helvetica", "bold");
  doc.setFontSize(14);
  doc.text(judul, pageWidth / 2, reportY, {
    align: "center",
  });

  doc.setFont("helvetica", "normal");
  doc.setFontSize(11);
  doc.text(subJudul, pageWidth / 2, reportY + 7, {
    align: "center",
  });

  return reportY + 13;
};

  // Judul
  const judul = "LAPORAN TUNGGAKAN";
  const subJudul = `${periode}`;

  const headers = [["No", "No. Anggota", "Nama", "Unit Kerja", "Tunggakan"]];

  const body = data.map((item, index) => [
    index + 1,
    item.noanggota || "-",
    item.nama || "-",
    item.unitkerja || "-",
    item.angs_a ? Number(item.angs_a).toLocaleString("id-ID") : "0"
  ]);

  // Total Angsuran A
  const totalAngsA = data.reduce((sum, item) => sum + (parseFloat(item.angs_a) || 0), 0);

  body.push([
    "", "", "TOTAL", "",
    totalAngsA.toLocaleString("id-ID")
  ]);

 const renderTable = (startY) => {
  autoTable(doc, {
    head: headers,
    body,
    startY,

    theme: "grid",

    styles: {
      fontSize: 9,
      cellPadding: 2,
      valign: "middle",
    },

    headStyles: {
      fillColor: [22, 160, 133],
      textColor: 255,
      fontStyle: "bold",
      halign: "center",
    },

    columnStyles: {
      0: {
        halign: "center",
        cellWidth: 10,
      },
      1: {
        halign: "center",
        cellWidth: 30,
      },
      2: {
        halign: "left",
        cellWidth: 60,
      },
      3: {
        halign: "left",
        cellWidth: 50,
      },
      4: {
        halign: "right",
        cellWidth: 35,
      },
    },

    didParseCell: (hookData) => {
      if (hookData.row.index === body.length - 1) {
        hookData.cell.styles.fontStyle = "bold";
        hookData.cell.styles.fillColor = [230, 230, 230];
      }
    },

    didDrawPage: (data) => {
      doc.setFontSize(8);

      doc.text(
        `Page ${doc.internal.getNumberOfPages()}`,
        data.settings.margin.left,
        doc.internal.pageSize.height - 8
      );
    },

    margin: {
      left: 15,
      right: 15,
      top: 20,
      bottom: 10,
    },

    showHead: "everyPage",
  });

  const pdfBlob = doc.output("blob");
  const pdfUrl = URL.createObjectURL(pdfBlob);

  window.open(pdfUrl, "_blank");
};
const customLogoUrl = "/koperasihitamputih.png";

loadImageAsDataURL(customLogoUrl)
  .then((logoDataUrl) => {
    const startY = drawHeader(judul, subJudul, logoDataUrl);
    renderTable(startY);
  })
  .catch(() => {
    const startY = drawHeader(judul, subJudul);
    renderTable(startY);
  });
};

export default mutasiTunggakanPdf;
